import styled, { css } from 'styled-components'

export const Container = styled.div`
  min-height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 2rem 1rem;
`

export const Header = styled.div`
  text-align: center;
  margin-bottom: 3rem;
  padding-top: 2rem;
`

export const BackButton = styled.button`
  background: rgba(255, 255, 255, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.3);
  color: white;
  padding: 0.5rem 1rem;
  border-radius: 6px;
  cursor: pointer;
  font-size: 0.875rem;
  margin-bottom: 2rem;
  transition: all 0.2s;

  &:hover {
    background: rgba(255, 255, 255, 0.3);
  }
`

export const Title = styled.h1`
  font-size: 3rem;
  font-weight: 700;
  color: white;
  margin: 0 0 1rem 0;
`

export const Subtitle = styled.p`
  font-size: 1.25rem;
  color: rgba(255, 255, 255, 0.9);
  margin: 0;
`

export const PricingGrid = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 2rem;
  margin-bottom: 4rem;
`

export const PricingCard = styled.div<{ $featured?: boolean }>`
  background: white;
  border-radius: 12px;
  padding: 2rem;
  position: relative;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1),
    0 10px 10px -5px rgba(0, 0, 0, 0.04);
  transition: transform 0.2s;

  ${props =>
    props.$featured &&
    css`
      border: 2px solid #3182ce;
      transform: scale(1.05);

      @media (max-width: 768px) {
        transform: scale(1);
      }
    `}

  &:hover {
    transform: ${props => (props.$featured ? 'scale(1.07)' : 'scale(1.02)')};

    @media (max-width: 768px) {
      transform: scale(1);
    }
  }
`

export const Popular = styled.div`
  position: absolute;
  top: -12px;
  left: 50%;
  transform: translateX(-50%);
  background: #3182ce;
  color: white;
  padding: 0.25rem 1rem;
  border-radius: 12px;
  font-size: 0.875rem;
  font-weight: 600;
`

export const PlanName = styled.h2`
  font-size: 1.5rem;
  font-weight: 600;
  color: #1a202c;
  margin: 0 0 1rem 0;
`

export const PlanPrice = styled.div`
  display: flex;
  align-items: baseline;
  gap: 0.5rem;
  margin-bottom: 1rem;
`

export const PriceAmount = styled.span`
  font-size: 3rem;
  font-weight: 700;
  color: #1a202c;
`

export const PricePeriod = styled.span`
  font-size: 1rem;
  color: #718096;
`

export const PlanDescription = styled.p`
  color: #718096;
  margin: 0 0 2rem 0;
`

export const FeaturesList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0 0 2rem 0;
`

export const Feature = styled.li`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 1rem;
  color: #4a5568;
`

export const FeatureIcon = styled.span`
  color: #48bb78;
  font-weight: 600;
  font-size: 1.125rem;
`

export const SelectButton = styled.button<{ $featured?: boolean }>`
  width: 100%;
  padding: 0.875rem;
  border: none;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;

  ${props =>
    props.$featured
      ? css`
          background: #3182ce;
          color: white;

          &:hover:not(:disabled) {
            background: #2c5282;
          }
        `
      : css`
          background: white;
          color: #3182ce;
          border: 2px solid #3182ce;

          &:hover:not(:disabled) {
            background: #ebf8ff;
          }
        `}

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`

export const CurrentPlan = styled.div`
  width: 100%;
  padding: 0.875rem;
  background: #e2e8f0;
  color: #4a5568;
  text-align: center;
  border-radius: 8px;
  font-weight: 600;
`

export const FreeCard = styled.div`
  background: white;
  border-radius: 12px;
  padding: 2rem;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
`

export const FreeTitle = styled.h2`
  font-size: 1.5rem;
  font-weight: 600;
  color: #1a202c;
  margin: 0 0 1rem 0;
`

export const FreeDescription = styled.p`
  color: #718096;
  margin: 0 0 1.5rem 0;
`

export const FreeFeatures = styled.div`
  margin-bottom: 2rem;
`

export const ComparisonSection = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  background: white;
  border-radius: 12px;
  padding: 3rem 2rem;
  margin-bottom: 3rem;
`

export const ComparisonTitle = styled.h2`
  font-size: 2rem;
  font-weight: 600;
  color: #1a202c;
  text-align: center;
  margin: 0 0 2rem 0;
`

export const ComparisonTable = styled.div`
  overflow-x: auto;
`

export const TableHeader = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 1fr;
  background: #f7fafc;
  border-radius: 8px 8px 0 0;

  @media (max-width: 768px) {
    font-size: 0.875rem;
  }
`

export const TableRow = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 1fr;
  border-bottom: 1px solid #e2e8f0;

  &:last-child {
    border-bottom: none;
  }

  @media (max-width: 768px) {
    font-size: 0.875rem;
  }
`

export const TableCell = styled.div<{ $header?: boolean; $featured?: boolean }>`
  padding: 1rem;

  ${props =>
    props.$header &&
    css`
      font-weight: 600;
      color: #2d3748;
    `}

  ${props =>
    props.$featured &&
    css`
      background: rgba(49, 130, 206, 0.05);
    `}
  
  ${props =>
    !props.$header &&
    css`
      color: #4a5568;
    `}
`

export const CheckIcon = styled.span`
  color: #48bb78;
  font-weight: 600;
`

export const CrossIcon = styled.span`
  color: #fc8181;
  font-weight: 600;
`

export const Footer = styled.div`
  text-align: center;
  padding-bottom: 3rem;
`

export const FooterText = styled.p`
  color: rgba(255, 255, 255, 0.9);
  margin: 0.5rem 0;
`

export const FooterLink = styled.a`
  color: white;
  font-weight: 600;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`
